<template>
  <div class="bg-secondary-28 border-color--gray-5 rounded p-3 ml-3 ml-md-0">
    <div class="row">
      <div class="col-md-3 col-sm-12">
        <div>
          <div class="color-secondary-6 font-14">Año Académico:</div>
          <div class="color-secondary-29">
            {{ item.academicYear.name }}
          </div>
        </div>
        <div class="mt-4">
          <div class="color-secondary-6 font-14">No. de Plan:</div>
          <div class="color-secondary-29">
            {{ item.actionPlanNumber }}
          </div>
        </div>
        <div class="mt-4">
          <div class="color-secondary-6 font-14">Centro:</div>
          <div class="color-secondary-29">
            {{ item.center.name }}
          </div>
        </div>
        <div class="mt-4">
          <div class="color-secondary-6 font-14">Municipio:</div>
          <div class="color-secondary-29">
            {{ item.municipality.name }}
          </div>
        </div>
        <div class="mt-4">
          <div class="color-secondary-6 font-14">Escuela:</div>
          <div class="color-secondary-29">
            {{ item.school.name }}
          </div>
        </div>
      </div>
      <div class="col-md-9 col-sm-12 border-left mt-3 mt-md-0">
        <div class="row bg-white rounded mx-0 mx-md-2">
          <div class="col-4 col-sm col-12 py-3">
            <div class="color-secondary-6 font-14">Añadido Por:</div>
            <div class="color-secondary-29">
              {{ item.createdByName }}
            </div>
          </div>
          <div class="col-4 col-sm col-12 py-3">
            <div class="color-secondary-6 font-14">Fecha:</div>
            <div class="color-secondary-29">
              {{ item.createdDate | formatDate }}
            </div>
          </div>
        </div>
        <div class="row my-3">
          <div class="col-12 mx-2">
            <div class="color-secondary-6 font-14 mt-3 mb-2">
              Seguimiento de Plan
            </div>
            <div class="mr-3">
              <follow-up
                readonly
                hide-title
                :initial-data="item"
                @save="() => {}"
                @cancel="() => {}"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// child components
import { FollowUp } from '@/views/pei/location-alternatives/search/actionPlan/components';
export default {
  name: 'FollowUpHistoryResult',
  components: {
    FollowUp,
  },
  props: {
    item: {
      type: Object,
      required: true,
      default: null,
    },
  },
};
</script>
